import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Answers, CheckState } from 'src/types/types.ts';

import { CheckContext } from './check-context';

export function CheckProvider({ children }: { children: React.ReactNode }) {
  const [answers, setAnswers] = useState<Answers>({});
  const [sectionIdx, setSectionIdx] = useState(0);
  const [subgroupIdx, setSubgroupIdx] = useState(0);
  const [questionIdx, setQuestionIdx] = useState(0);
  const [transitionFrom, setTransitionFrom] = useState<number | null>(null);
  const [legendOverride, setLegendOverride] = useState<boolean | null>(null);
  const [context, setContext] = useState<{
    size?: string;
    type?: string;
    role?: string;
  }>({});
  const [contextStep, setContextStep] = useState(0);
  const [lead, setLead] = useState({
    name: '',
    company: '',
    email: '',
    consent: false
  });
  const [arcId, setArcId] = useState('');

  const navigate = useNavigate();
  function reset() {
    setAnswers({});
    setSectionIdx(0);
    setSubgroupIdx(0);
    setQuestionIdx(0);
    setTransitionFrom(null);
    setLegendOverride(null);
    setContext({});
    setContextStep(0);
    setLead({ name: '', company: '', email: '', consent: false });
    setArcId('');
    navigate('/');
  }

  const value: CheckState = {
    answers,
    setAnswers,
    sectionIdx,
    setSectionIdx,
    subgroupIdx,
    setSubgroupIdx,
    questionIdx,
    setQuestionIdx,
    transitionFrom,
    setTransitionFrom,
    legendOverride,
    setLegendOverride,
    context,
    setContext,
    contextStep,
    setContextStep,
    lead,
    setLead,
    arcId,
    setArcId,
    reset
  };

  return <CheckContext.Provider value={value}>{children}</CheckContext.Provider>;
}
